module.exports = __webpack_public_path__ + "ebe87fad4baad0821a44f37569742ded.mp4";